export { default as AppointmentDetailsList } from './AppointmentDetailsList';
